'use client';
import React from 'react';
import { BaseInput, type BaseInputProps } from './';

type TextInputProps = Omit<BaseInputProps, 'stepper'> & {
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string) => void;
};

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (props, ref) => {
    const { type = 'text', ...other } = props;
    return <BaseInput ref={ref} type={type} {...other} />;
  },
);

TextInput.displayName = 'TextInput';

export { TextInput, type TextInputProps };
